import React from 'react'

export type QuotaState = { exceeded: boolean; nextResetAt: string | null; resolved: boolean }
type Ctx = QuotaState & { setQuota: (s: Partial<QuotaState>) => void }

const QuotaContext = React.createContext<Ctx | null>(null)

export function QuotaProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = React.useState<QuotaState>({ exceeded: false, nextResetAt: null, resolved: false })
  const setQuota = React.useCallback((s: Partial<QuotaState>) => setState((p) => ({ ...p, ...s })), [])
  const value = React.useMemo(() => ({ ...state, setQuota }), [state, setQuota])
  return <QuotaContext.Provider value={value}>{children}</QuotaContext.Provider>
}

export function useQuota(): Ctx {
  const ctx = React.useContext(QuotaContext)
  if (!ctx) return { exceeded: false, nextResetAt: null, resolved: false, setQuota: () => {} }
  return ctx
}
